import { toast } from 'react-toastify';

import { JAVA_API_STATUS } from '../../utils/axios-interceptor';
import { getCompanyConfigData } from './service';
import { USER_TYPE } from '../../utils/constants/user';

// Split out of `apiHelpers` to sidestep a pre-existing, repo-wide jest limitation — nothing
// about this feature. Importing `store/company/apiHelpers` in a suite fails to load with
// `SyntaxError: Unexpected token 'export'` from `colors-named`, reached via
// apiHelpers -> store/store.ts -> ... -> PlateEditor -> @uiw/react-color -> @uiw/react-color-name.
// `colors-named` is ESM-only and missing from the jest transform allowlist `PLATE_PACKAGES`
// in `craco.config.ts` (last entry `gapi-script`). Seven suites already work around it with
// `jest.mock`, e.g.
// modules/Dashboard/DashboardModules/ManagementProfileTab/__tests__/ManagementProfileTab.characterization.test.tsx:153-156.
// Adding `colors-named` to `PLATE_PACKAGES` would fix it at the root and let this split be
// reverted; that is deliberately a separate change, since it alters how every suite loads.
// Until then, consumers that only need the signup config import this file instead.
//
// This helper owns the failure notification: both failure paths below toast before calling
// `onError`, so an `onError` that toasts as well shows the user the same error twice.
export async function getCompanyConfigDataAndSetFormData(payload, handlers) {
    try {
        const configResponse = await getCompanyConfigData({
            accountType: payload.accountType ? payload.accountType : USER_TYPE.COMPANY,
            investorOrgId: payload.investorOrgId,
            primaryEmail: payload.primaryEmail,
            configName: 'AICA_SIGNUP_ADDITIONAL_DETAILS',
        });

        switch (configResponse?.data?.responseData?.responseCode) {
            case JAVA_API_STATUS.SUCCESS:
                const configData = configResponse?.data?.mainConfig;
                const orgDisplayName = configResponse?.data?.organizationDisplayName;
                handlers?.onSuccess?.(configData, orgDisplayName);
                break;
            case JAVA_API_STATUS.ERROR:
            default:
                toast.error(configResponse?.data?.responseData?.responseMessage || 'Error fetching application details config');
                handlers?.onError?.();
                break;
        }
    } catch (error) {
        console.error('Error in getCompanyConfigDataAndSetFormData:', error);
        toast.error('Error fetching application details config');
        handlers?.onError?.();
    }
}
